import { IconPlus } from "@tabler/icons-react";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import {
	useDeleteReports,
	useReportsPaged,
} from "@/common/artemis-operations/reports";
import {
	DELETE_RESOURCE_ERROR_FAILED,
	DELETE_RESOURCE_INFO_COMPLETED,
} from "@/common/messages";
import { useNotify } from "@/common/use-notify";
import { BasePageContainer, CustomIcon, QueryGuard } from "@/components/base";
import { ReportTable } from "@/components/reports/report-table";
import { useActions } from "@/contexts/actions-context";
import { usePageTitle } from "@/contexts/page-title-context";
import { useWizards } from "@/contexts/wizard-context";

export const Route = createFileRoute(
	"/_authenticated/$orgSlug/workspaces/$workspaceId/reports/",
)({
	component: Reports,
});

function Reports() {
	const { workspaceId } = Route.useParams();
	const { setTitle } = usePageTitle();
	const { setActions } = useActions();
	const notify = useNotify();
	const { openReportCreateWizard } = useWizards();

	const list = useReportsPaged(workspaceId);
	const { mutate: deleteReports } = useDeleteReports();

	useEffect(() => {
		setTitle("Reports");
		setActions([
			{
				type: "button",
				id: "create",
				// label: "Report",
				tooltip: "New report",
				icon: <CustomIcon icon={IconPlus} />,
				onClick: openReportCreateWizard,
			},
		]);
		return () => setActions([]);
	}, [setTitle, setActions, openReportCreateWizard]);

	return (
		<QueryGuard isPending={list.loading} isError={list.isError}>
			<BasePageContainer>
				<ReportTable
					data={list.rows}
					loading={list.isFetching}
					totalCount={list.totalCount}
					hasNextPage={list.hasNextPage}
					hasPreviousPage={list.hasPreviousPage}
					pageIndex={list.pageIndex}
					onNextPage={list.onNextPage}
					onPreviousPage={list.onPreviousPage}
					pageSize={50}
					manualSorting
					initialSorting={list.sort}
					onSortingChange={list.setSort}
					search={list.search}
					onSearchChange={list.setSearch}
					type={list.filters.type}
					onTypeChange={(v) => list.setFilter("type", v)}
					status={list.filters.status}
					onStatusChange={(v) => list.setFilter("status", v)}
					onRefresh={() => list.refetch()}
					onDeleteReports={(selected) => {
						deleteReports(
							selected.map((d) => d.id as string),
							{
								onSuccess: () => notify.success(DELETE_RESOURCE_INFO_COMPLETED),
								onError: () => notify.error(DELETE_RESOURCE_ERROR_FAILED),
							},
						);
					}}
				/>
			</BasePageContainer>
		</QueryGuard>
	);
}
